class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.addEventListener('click', this.handleClick.bind(this));
  }
  
  connectedCallback() {
    this.classList.add('cart-drawer');
    this.setAttribute('aria-hidden', 'true');
  
    this.closeButton = this.querySelector('.cart-drawer__close');
    this.closeButton.setAttribute('aria-label', 'Close cart');
    this.closeButton.addEventListener('click', () => this.close());

    const cartLinks = document.querySelectorAll('a[href*="/cart"]');
    cartLinks.forEach(link => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        this.open();
      });
    }); 

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('cart') && urlParams.get('cart') === 'open') {
      this.open();
    }
  }
  
  handleClick(event) {
    if (event.target.closest('.cart-drawer__close')) {
      this.close();
      event.preventDefault();
    }
  }
  
  open() {
    if (this.isOpen) return;
    
    this.isOpen = true;
    this.classList.add('is-active');
    this.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
    document.body.style.setProperty('overflow', 'hidden');
    
    // Add overlay if needed
    this.addOverlay();
    
    // Announce to screen readers
    this.announceOpen();
  }
  
  close() {
    if (!this.isOpen) return;
    
    this.isOpen = false;
    this.classList.remove('is-active');
    this.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
    document.body.style.removeProperty('overflow');
    
    // Remove overlay
    this.removeOverlay();
  }
  
  addOverlay() {
    // Create overlay element for background dimming
    if (!document.querySelector('.cart-drawer-overlay')) {
      const overlay = document.createElement('div');
      overlay.classList.add('cart-drawer-overlay');
      overlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 999;
        opacity: 0;
        transition: opacity 0.3s ease;
      `;
      document.body.appendChild(overlay);
      
      // Force reflow
      overlay.offsetHeight;
      
      // Add click handler to close drawer when clicking overlay
      overlay.addEventListener('click', () => this.close());
      
      // Fade in
      overlay.style.opacity = '1';
    }
  }
  
  removeOverlay() {
    const overlay = document.querySelector('.cart-drawer-overlay');
    if (overlay) {
      // Fade out
      overlay.style.opacity = '0';
      
      // Remove after transition
      setTimeout(() => {
        if (overlay.parentNode) {
          overlay.parentNode.removeChild(overlay);
        }
      }, 300);
    }
  }
  
  announceOpen() {
    // Announce to screen readers that cart is open
    const announcer = document.createElement('div');
    announcer.setAttribute('aria-live', 'polite');
    announcer.classList.add('visually-hidden');
    announcer.textContent = 'Cart drawer opened';
    
    document.body.appendChild(announcer);
    setTimeout(() => {
      document.body.removeChild(announcer);
    }, 1000);
  }
  
}

customElements.define('cart-drawer', CartDrawer);